/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxFrag */
import { type ReactNode } from 'react';

import { jsx } from '@compiled/react';

import { NavigationAnalyticsContext } from '@atlaskit/analytics-namespaced-context';

/**
 * This component exists just to wrap the given content with NavigationAnalyticsContext with
 * the context data to be passed down to child components' analytics events.
 * At the time of writing, it's only used in one place in production code,
 * but having it abstracted out allows us to also use it in tests/examples such as for the inner ModalDialogContent.
 * It also allows us to simplify the application of the feature gate for analytics.
 */
export function AnalyticsContextWrapper({
	product,
	children,
}: {
	children: ReactNode;
	product: string;
}): JSX.Element {
	return (
		<NavigationAnalyticsContext
			data={{
				componentName: 'globalInvite',
				source: 'globalInviteButton',
				product: product,
			}}
		>
			{children}
		</NavigationAnalyticsContext>
	);
}
